import './Flash-a3596568.css';

var classes = {"Flash":"prc-Flash-Flash-3q4Aj"};

export { classes as default };
